// extracted by mini-css-extract-plugin
module.exports = {"meal":"MealItem_meal__ipmoI","description":"MealItem_description__1Zs5s","price":"MealItem_price__13OV9"};